import React from "react";
import Link from "next/link";
export default function FooterV2() {
  let footerItems = [
    {
      title:'Product',
      footerLinks:[
        {
          title:'Infrastructure Monitoring',
          link:'/product/infrastructure-monitoring/'
        },
        {
          title:'Log Monitoring',
          link:'/product/log-monitoring/'
        },
        {
          title:'APM',
          link:'/product/apm/'
        },
        {
          title:'Metrics',
          link:'/product/metrics/'
        },
        {
          title:'Distributed Tracing',
          link:'/product/distributed-tracing/'
        },
        {
          title:'Database Monitoring',
          link:'/product/database-monitoring/'
        },
        {
          title:'Real User Monitoring',
          link:'/product/real-user-monitoring/',
        },
        {
          title:'Synthetic Monitoring',
          link:'/product/synthetic-monitoring/'
        },
        {
          title:'Container Monitoring',
          link:'/product/container-monitoring/'
        },
        {
          title:'Serverless Monitoring',
          link:'/product/serverless-monitoring/'
        },
        {
          title:'LLM Observability',
          link:'/product/llm-observability/',
          isNew: true
        },
        {
          title:'Browser Testing',
          link:'/product/browser-testing/',
          isNew: true
        },
      ]
    },
    {
      title:'Our Platform',
      footerLinks:[
        {
          title:'Overview',
          link:'/platform/'
        },
        {
          title:'Unified Experience',
          link:'/platform/unified-experience/'
        },
        {
          title:'Alerts',
          link:'/platform/alerts/'
        },
        {
          title:'Query Language',
          link:'/platform/query-language/'
        },
        {
          title:'Pipeline',
          link:'/platform/observability-pipeline/'
        },
        {
          title:'Integrations',
          link:'/platform/integrations/'
        },
        {
          title:'Session Replay',
          link:'/product/real-user-monitoring/session-replays/'
        },
        {
          title:'Error Tracking',
          link:'/product/real-user-monitoring/error-tracking/'
        },
        {
          title:'Continuous Profiler',
          link:'/product/continuous-profiler/'
        },
        {
          title:'Query Genie',
          link:'/product/query-genie/',
          isNew: true
        },
      ]
    },
    {
      title:'Our Solution',
      footerLinks:[
        // {
        //   title:'Digital Experience Monitoring',
        //   link:'/solutions/digital-experience-monitoring/'
        // },
        // {
        //   title:'Industry',
        //   link:'/solutions/industry/'
        // },
        {
          title:'Technology',
          link:'/solutions/technology/'
        },
        {
          title:'AWS',
          link:'/solutions/aws/'
        },
        {
          title:'Azure',
          link:'/solutions/azure/',
        },
        {
          title:'GCP',
          link:'/solutions/gcp/',
        },
      ],
      subItem: [
        {
          title:'Comparison',
          footerLinks:[
            {
              title:'Datadog Alternative',
              link:'/comparison/datadog-alternative/'
            },
            {
              title:'Newrelic Alternative',
              link:'/comparison/newrelic-alternative/'
            },
            {
              title:'Dynatrace Alternative',
              link:'/comparison/dynatrace-alternative/'
            },
            {
              title:'Grafana Alternative',
              link:'/comparison/grafana-vs-middleware/'
            },
          ]
        },
      ]
    },
    {
      title:'Resources',
      footerLinks:[
        {
          title:'Customers',
          link:'/customers/'
        },
        {
          title:'Community',
          link:'https://community.middleware.io',
          newTab: true
        },
        {
          title:'Events',
          link:'/events/'
        },
        {
          title:'Whitepapers',
          link:'/resources/'
        },
        {
          title:'Newsletter',
          link:'https://newsletters.middleware.io/',
          newTab: true
        },
        {
          title:'Media Coverage',
          link:'/resources/media-coverage/'
        },
        {
          title:'Blog',
          link:'/blog/'
        },
        // {
        //   title:'Techscribe',
        //   link:'/technical-writer-program/'
        // },
        {
          title:'Help-Docs',
          link:'https://docs.middleware.io/quickstart',
          newTab: true
        },
        {
          title:'API-Docs',
          link:'https://docs.middleware.io/public-api/api',
          newTab: true
        },
        {
          title:'Product Updates',
          link:'/product-updates/',
        },
        {
          title:'Podcasts',
          link:'/podcast/',
        },

      ]
    },
    {
      title:'Company',
      footerLinks:[
        {
          title:'About Us',
          link:'/about-us/'
        },
        {
          title:'Careers',
          link:'/careers/'
        },
        {
          title:'Partner',
          link:'/partners/'
        },
        {
          title:'Contact Us',
          link:'/contact-us/'
        },
      ],
      subItem: [
        {
          title:'Security ',
          footerLinks:[
            {
              title:'Security',
              link:'/security/'
            },
            {
              title:'GDPR',
              link:'/gdpr/'
            },
          ]
        },
      ]
    },
  ]
  let socialIcons = [
    {
      icon:'/images/social-icon/linkdIn.svg',
      link:'https://www.linkedin.com/company/middleware-labs/',
      class: 'social-icon',
      newTab: true
    },
    {
      icon:'/images/social-icon/git.svg',
      link:'https://github.com/middleware-labs/',
      class: 'social-icon',
      newTab: true
    },
    {
      icon:'/images/social-icon/twitter.svg',
      link:'https://twitter.com/middleware_labs/',
      class: 'social-icon',
      newTab: true
    },
    {
      icon:'/images/social-icon/youtube.svg',
      link:'https://www.youtube.com/channel/UCjYP2EQiEgHryxR0dgpt0YA/',
      class: 'social-icon',
      newTab: true
    },
    {
      icon:'/images/social-icon/slack.svg',
      link:'https://middlewarepublic.slack.com/join/shared_invite/zt-27q52ajad-Wbe8q2SDQYxrzWgnoOtF9w',
      class: 'social-icon',
      newTab: true
    },
    {
      icon:'/images/social-icon/facebook.svg',
      link:'https://www.facebook.com/middlewarelabs/',
      class: 'social-icon',
      newTab: true
    },
    {
      icon:'/images/social-icon/community.svg',
      link:'https://community.middleware.io',
      class: 'social-icon',
      newTab: true
    }
  ]

  const year = new Date().getFullYear();
  return (
      <footer>
        <div className={'site-footer'}>
          <div className={'container'}>
            <div className={'footer-links'}>
              {footerItems.map((item, index)=>{
                return <div className={'link-wrapper'} key={index}>
                  <h5>{item.title}</h5>
                  <ul>
                    {item.footerLinks.map((__item, __index) => (
                        <li key={__index}>
                          <Link key={__item.title + __index} href={__item.link} target={__item.newTab ? "_blank" : ""}>
                            {__item.title}
                            {__item.isNew && <img src={"/images/product/new_features_dark.svg"} alt={"New Feature"} width={100} height={100} className={"new_features"}/>}
                          </Link>
                        </li>
                    ))}

                    {item.subItem && item.subItem.map((__sub, index) => (
                        <li key={index} className="sub-menu-item">
                          <h5>{__sub.title}</h5>
                          <ul>
                            {__sub.footerLinks.map((__item1, __index) => (
                                <li key={__index}>
                                  <Link key={__item1.title + __index} href={__item1.link}>{__item1.title}</Link>
                                </li>
                            ))}
                          </ul>
                        </li>
                    ))}
                  </ul>

                </div>
              })}
            </div>

            <div className={"footer-logos"}>
              <div className={"d-flex"}>
                <div className={"item-logo"}>
                  <Link href={'/'}><div className={'logo-footer'}><img src={"/images/logo-mw-white.svg"} alt={"Middleware’s white logo"} loading={'lazy'} width={'215'} height={'28'} /></div></Link>
                </div>
                <div className={"item-logo"}>
                  <div className={"soc-gdpr"}>
                      <img src={"/images/gdpr-footer.svg"} alt={"GDPR"} width={"100"} height={"100"} loading={"lazy"}/>
                      <img src={"/images/soc2type.svg"} alt={"SOC-2 Type II"} width={"100"} height={"100"} loading={"lazy"}/>
                      <img src={"/images/hipaa.svg"} alt={"HIPAA"} width={"100"} height={"100"} loading={"lazy"} className={"hipaa"}/>
                  </div>
                </div>
                <div className={"item-logo"}>
                    <div className={'d-flex social-icons'}>
                      {socialIcons.map((item,index)=>{
                        return <Link href={item.link} key={index} target={item.newTab ? "_blank" : "_self"}><div className={item.class} >
                          <img src={item.icon} alt={'social-icon'} loading={'lazy'} width={'28'} height={'28'}></img>
                        </div></Link>
                      })}
                    </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div className={'footer-bottom-area'}>
          <div className={"container"}>
            <div className={'d-flex'}>
              <p>©{year} Middleware, All rights reserved</p>
              <ul>
                <li><Link href={"/privacy-policy/"}>Privacy-Policy</Link></li>
                <li><Link href={"/terms-and-conditions/"}>Terms & Conditions</Link></li>
                <li><Link href={"/cookie-policy/"}>Cookie-Policy</Link></li>
              </ul>
            </div>
          </div>
        </div>

      </footer>
  )
}
